<template>
  <div>
    <a-page-header :style="{ padding: '8px' }" :sub-title="activeStatus.subtitle">
      <template #title>
        <span :class="'status-icon icon-' + activeStatus.status"><a-icon :theme="activeStatus.icon === 'loading' ? 'outlined' : 'filled'"
                                                                         :type="activeStatus.icon"/></span>
        {{ activeStatus.title }}
      </template>
      <template #extra>
        <a-button v-if="activeStatus.createAccount" icon="edit" size="large" type="danger" @click="() => goTo('Form')">
          Zarejestruj się
        </a-button>
        <a-button v-if="activeStatus.loginAccount" icon="user" size="large" type="primary" @click="() => goTo('Login')">
          Zaloguj się
        </a-button>
        <a-button v-if="activeStatus.showContact" icon="message" type="primary" @click="() => goTo('Contact')">
          Wejdź na czat
        </a-button>
      </template>
      <a-row v-if="form.reason">
        <a-col>
          {{ form.reason }}
        </a-col>
      </a-row>
      <a-row v-if="activeStatus.showProcess" :style="{
        marginTop: '1.2em',
        paddingBottom: '1em',
        overflowX: 'auto',
      }">
        <a-col>
          <h3>{{ process.name }}</h3>
          <a-steps :current="process.progress - 1" :direction="computedProcessViewDirection" size="small">
            <a-step v-for="task in process.tasks" :key="task.id" :description="task.description" :status="task.status"
                    :title="task.title"/>
          </a-steps>
        </a-col>
      </a-row>
    </a-page-header>
  </div>
</template>

<script>
import httpClient from "@/utils/httpClient";

const statusesDictionary = {
  LOADING: {
    status: "info",
    icon: "loading",
    title: "Ładowanie",
    subtitle: "Trwa pobieranie statusu połączenia. Prosimy o chwilę cierpliwości.",
    createAccount: false,
    loginAccount: false,
    showProcess: false,
    showContact: false,
  },
  INACTIVE: {
    status: "warning",
    icon: "warning",
    title: "Brak dostępu do sieci",
    subtitle:
        "Jeśli nie posiadasz konta w systemie to złóż wniosek. W przeciwnym wypadku zaloguj się i dodaj nowe urządzenie.",
    createAccount: true,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
  WAITING: {
    status: "warning",
    icon: "warning",
    title: "Wniosek oczekujący",
    subtitle: "Wniosek został złożony. Trwa procesowanie.",
    createAccount: false,
    loginAccount: false,
    showProcess: true,
    showContact: false,
  },
  ACTIVE: {
    status: "success",
    icon: "check-circle",
    title: "Dostęp aktywny",
    subtitle:
        'Wszystko działa prawidłowo. Możesz się zalogować na swoje konto. Jeśli masz problemy z dostępem to skorzystaj z zakładki "Pomoc"',
    createAccount: false,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
  ALMOST_ACTIVE: {
    status: "info",
    icon: "clock-circle",
    title: "Odłącz kabel 1 minutę",
    subtitle:
        'Konto zostało aktywowane. Odłącz kabel na około 1 minutę i podłącz ponownie, aby wszystko zaczęło działać prawidłowo. Je',
    createAccount: false,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
  PROBLEM: {
    status: "info",
    icon: "question-circle",
    title: "Problem",
    subtitle:
        "Twoje urządzenie nie może połączyć się z internetem. Prosimy o kontakt.",
    createAccount: false,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
  BANNED: {
    status: "error",
    icon: "exclamation-circle",
    title: "Blokada dostępu",
    subtitle:
        "Dostęp do sieci został zablokowany. Aby sprawdzić powód blokady zaloguj się na konto użytkownika.",
    createAccount: false,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
  DEPRECATED: {
    status: "purple",
    icon: "clock-circle",
    title: "Konto wygasło",
    subtitle:
        "Konto wygasło. Aby w pełni aktywować dostęp zaloguj się na konto i aktywuj dostęp ponownie.",
    createAccount: false,
    loginAccount: true,
    showProcess: false,
    showContact: false,
  },
};

export default {
  data() {
    return {
      windowWidth: 0,
      form: {
        status: "LOADING",
        reason: null
      },
      process: {
        name: "Proces weryfikacji",
        progress: 2,
        tasks: [
          {
            id: 1,
            title: "Rejestracja",
            description: "Złożenie wniosku w formie elektronicznej",
            status: "", // error
          },
          {
            id: 2,
            title: "Weryfikacja danych",
            description: "Oczekiwanie na weryfikację danych",
            status: "",
          },
          {
            id: 3,
            title: "Aktywacja",
            description: "Udzielenie dostępu do sieci",
            status: "",
          },
          {
            id: 4,
            title: "Wymagana akcja",
            description: "Odłącz kabel na 1 minutę",
            status: "",
          },
        ],
      },
    };
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    let getStatusInterval = setInterval(() => {
      httpClient
          .get(`/identity/status`)
          .then((response) => {
            this.form.status = response.accountStatus;
            this.form.reason = response.reason;
            if (this.form.status === 'ACTIVE' && !this.computedSession.isAccessGood) {
              this.form.status = 'ALMOST_ACTIVE'
            }
            if (this.form.status !== "WAITING" && this.form.status !== "ALMOST_ACTIVE") {
              clearInterval(getStatusInterval);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }, 3000);
  },
  computed: {
    computedProcessViewDirection: function () {
      return this.windowWidth < 1200 ? "vertical" : "horizontal";
    },
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
    activeStatus: function () {
      let status = statusesDictionary[this.form.status] || statusesDictionary.INACTIVE
      if (this.form.status !== 'LOADING') {
        status.loginAccount = this.computedSession !== undefined && !this.computedSession.isLoggedIn
      }
      return status
    }
  },
  methods: {
    goTo: function (name) {
      this.$router.push({name: name});
    },
  },
};
</script>

<style scoped>
.status-icon {
  margin-right: 16px;
}

.icon-warning {
  color: orange;
}

.icon-success {
  color: rgb(64, 172, 2);
}

.icon-error {
  color: rgb(219, 0, 0);
}

.icon-purple {
  color: rgb(161, 0, 201);
}

.icon-info {
  color: rgb(0, 174, 255);
}
</style>
